import {Stack} from '@mui/material';
import React, {forwardRef, useImperativeHandle} from 'react';
import {SaveButton} from '../SaveButton';
import {TherapySessions} from '../TherapySessions';
import {useTherapySessions} from '../TherapySessions/hooks/useTherapySessions';
import type {TherapySessionsRef} from '../TherapySessions/types';
import {TherapyTypeField} from '../TherapyTypeField';

export const AddTherapyContentForm = forwardRef<TherapySessionsRef>((_, ref) => {
	const props = useTherapySessions();

	useImperativeHandle(ref, () => ({
		saveEditSession: props.saveEditSession,
		watchedSessions: props.watchedSessions,
	}));

	return (
		<>
			<Stack gap={2} flex={1} bgcolor={'white'} padding={2} borderRadius={1} mt={2}>
				<Stack direction={'column'} spacing={2}>
					<TherapyTypeField />

					<TherapySessions hookProps={props} />
				</Stack>
			</Stack>
			<SaveButton hookProps={props} />
		</>
	);
});
